import React from 'react';

import { Divider, Typography } from '@mui/material';
import { useTranslation } from 'next-i18next';

import BundleCourseItemHeaderSkeleton from './bundleCourseItemHeaderSkeleton/BundleCourseItemHeaderSkeleton';

import useBundleCourseItem from '@hooks/bundle/useBundleCourseItem';
import { useBreakpointV2 } from '@helpers/use';

const BundleCourseItemHeader = () => {
  const { t } = useTranslation('store_course');
  const { isMobile } = useBreakpointV2();
  const { bundleCourses, isBundleCoursesLoading } = useBundleCourseItem();

  if (isBundleCoursesLoading) {
    <BundleCourseItemHeaderSkeleton />;
  }

  return (
    <>
      <Typography variant={isMobile ? 'h6' : 'h4'}>
        {t('bundle_detail.bundle_course_items.header', { courseCount: bundleCourses.length })}
      </Typography>
      <Divider />
    </>
  );
};

export default BundleCourseItemHeader;
